export enum MethodFIRepaymentModalSteps {
    MANAGE_CONNECTED_LOAN_ACCOUNTS = 'manage-loan-connected-accounts',
    METHODFI_ELEMENT = 'methodfi-element'
}
